/** Central React Query key factory — keeps invalidation in sync across services. */
export const qk = {
  auth: {
    me: ["auth", "me"] as const,
    sessions: ["auth", "sessions"] as const,
  },
  public: {
    home: ["public", "home"] as const,
    settings: ["public", "settings"] as const,
    navigation: ["public", "navigation"] as const,
    teams: ["public", "teams"] as const,
    team: (id: string) => ["public", "teams", id] as const,
    players: (params?: unknown) => ["public", "players", params] as const,
    player: (id: string) => ["public", "players", id] as const,
    staff: ["public", "staff"] as const,
    fixtures: (params?: unknown) => ["public", "fixtures", params] as const,
    fixture: (id: string) => ["public", "fixtures", id] as const,
    results: (params?: unknown) => ["public", "results", params] as const,
    match: (id: string) => ["public", "matches", id] as const,
    matchLive: (id: string) => ["public", "matches", id, "live"] as const,
    liveMatch: ["public", "live-match"] as const,
    leagueTables: ["public", "league-tables"] as const,
    streams: (params?: unknown) => ["public", "streams", params] as const,
    stream: (id: string) => ["public", "streams", id] as const,
    articles: (params?: unknown) => ["public", "articles", params] as const,
    article: (slug: string) => ["public", "articles", slug] as const,
    videos: (params?: unknown) => ["public", "videos", params] as const,
    galleries: (params?: unknown) => ["public", "galleries", params] as const,
    gallery: (id: string) => ["public", "galleries", id] as const,
    sponsors: ["public", "sponsors"] as const,
  },
  player: {
    dashboard: ["player", "dashboard"] as const,
    profile: ["player", "profile"] as const,
    fixtures: ["player", "fixtures"] as const,
    results: ["player", "results"] as const,
    statistics: ["player", "statistics"] as const,
    trainingSessions: ["player", "training-sessions"] as const,
    attendance: ["player", "attendance"] as const,
    documents: ["player", "documents"] as const,
    videos: ["player", "videos"] as const,
    announcements: ["player", "announcements"] as const,
    notifications: ["player", "notifications"] as const,
  },
  coaching: {
    dashboard: ["coaching", "dashboard"] as const,
    team: (id: string) => ["coaching", "team", id] as const,
    trainingSessions: (params?: unknown) => ["coaching", "training-sessions", params] as const,
  },
  admin: {
    dashboard: ["admin", "dashboard"] as const,
    users: (params?: unknown) => ["admin", "users", params] as const,
    user: (id: string) => ["admin", "users", id] as const,
    roles: ["admin", "roles"] as const,
    permissions: ["admin", "permissions"] as const,
    teams: ["admin", "teams"] as const,
    players: (params?: unknown) => ["admin", "players", params] as const,
    fixtures: (params?: unknown) => ["admin", "fixtures", params] as const,
    match: (id: string) => ["admin", "matches", id] as const,
    streams: (params?: unknown) => ["admin", "streams", params] as const,
    articles: (params?: unknown) => ["admin", "articles", params] as const,
    media: (params?: unknown) => ["admin", "media", params] as const,
    galleries: ["admin", "galleries"] as const,
    sponsors: ["admin", "sponsors"] as const,
    enquiries: (params?: unknown) => ["admin", "enquiries", params] as const,
    auditLogs: (params?: unknown) => ["admin", "audit-logs", params] as const,
    settings: ["admin", "settings"] as const,
  },
} as const;
